<img class="header-logo" [ngClass]="styleClass" [src]="url" />
